import { raiseSocialEmbed } from "./functions";

jQuery(document).ready(function () {
  let waitTime = parseInt(show_social_embed.waitSeconds2);

  let showAds = show_social_embed.showAds === "1";
  let totalWaitTime = showAds ? 6000 + waitTime * 1000 : 1000;

  if (screen.width > 767) {
    if (showAds) {
      setTimeout(() => {
        raiseSocialEmbed();
      }, totalWaitTime);
    } else {
      $(window).on("load", function () {
        raiseSocialEmbed();
      });
    }
  }
});
